module.exports = __webpack_public_path__ + "static/media/nav_circle_active.5e7298fb.svg";